import React from "react";
import "./ManageCardWithDetails.scss";
import EditIcon from "../../assets/icons/EditIcon";
import DeleteIcon from "../../assets/icons/DeleteIcon";
const BASE_URL = process.env.REACT_APP_API_URL;

const ManageCardWithDetails = ({ stage, oneditclick, ondeleteclick }) => {

  let imgurl =    stage.stageImagePath;
  let timestamp = new Date().getTime();
  let cacheBypassUrl = `${imgurl}?t=${timestamp}`

  return (
    <div className="manage-card-details">
      <div className="stage-head">
        <div className="stage-name">
          <div
            className="stage-img"
            style={{
              maskImage: `url(${BASE_URL + cacheBypassUrl})`,
            }}
          ></div>
          <h3>{stage.roStageName}</h3>
        </div>
        <div className="action">
          <button className="btn edit" onClick={oneditclick}>
            <EditIcon />
          </button>
          <button className="btn delete" onClick={ondeleteclick}>
            <DeleteIcon />
          </button>
        </div>
      </div>
      <div className="card-details">
        <label>Expertise : </label>
        <p>
          {stage.expertises?.map((group) => group.expertiseName).join(", ")}
        </p>
        <label>Status : </label>
        <label className="card-label-bold">{stage.recordStatus}</label>
      </div>
    </div>
  );
};

export default ManageCardWithDetails;
